export default "__VITE_PUBLIC_ASSET__a2b1f79f__"